import React, { forwardRef, PropsWithChildren, useEffect } from 'react'
import { Callback } from 'Src/types/utilTypes'
import { useInView } from 'react-intersection-observer'
import { GridInfinityScrollRefStyled, GridInfinityScrollStyled } from './styled'

interface ComponentProps {
	getData?: Callback
	className?: string
}
export const GridInfinityScroll = forwardRef<HTMLDivElement, PropsWithChildren<ComponentProps>>(
	({ getData, className, children }, ref) => {
		const { ref: bottom, inView } = useInView({
			threshold: 0.1,
		})

		useEffect(() => {
			if (inView) getData?.()
		}, [inView])

		return (
			<GridInfinityScrollStyled ref={ref} className={className}>
				{children}
				<GridInfinityScrollRefStyled ref={bottom} />
			</GridInfinityScrollStyled>
		)
	}
)
